import { SiFacebook, SiGithub, SiInstagram, SiWhatsapp } from '@icons-pack/react-simple-icons'
import { FileTextIcon, FlameIcon, LinkIcon, PencilIcon, UserCircleIcon } from 'lucide-react'
import { FaLinkedin } from 'react-icons/fa'

import {
  SITE_FACEBOOK_URL,
  SITE_GITHUB_URL,
  SITE_INSTAGRAM_URL,
  SITE_X_URL,
  SITE_YOUTUBE_URL
} from '@/lib/constants'

type SocialLinks = Array<{
  href: string
  title: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement> & { className?: string }>
}>

export const HEADER_LINKS = [
  {
    icon: <PencilIcon className='size-3.5' />,
    href: '/blog',
    key: 'blog'
  },
  {
    icon: <FlameIcon className='size-3.5' />,
    href: '/projects',
    key: 'projects'
  },
  {
    icon: <UserCircleIcon className='size-3.5' />,
    href: '/about',
    key: 'about'
  },
  {
    icon: <FileTextIcon className='size-3.5' />,
    href: '/resume/resume.pdf',
    key: 'resume'
  },
  {
    icon: <LinkIcon className='size-3.5' />,
    href: 'https://linkaar.vercel.app/',
    key: 'links'
  }
] as const

export const FOOTER_LINKS = [
  {
    id: 1,
    links: [
      { href: '/', key: 'home' },
      { href: '/blog', key: 'blog' },
      { href: '/about', key: 'about' }
    ]
  },
  {
    id: 2,
    links: [
      { href: '/resume/resume.pdf', key: 'resume' },
      { href: '/projects', key: 'projects' },
      { href: 'https://linkaar.vercel.app/', key: 'links' }
    ]
  },
  {
    id: 3,
    links: [
      { href: SITE_FACEBOOK_URL, key: 'facebook' },
      { href: SITE_INSTAGRAM_URL, key: 'instagram' },
      { href: SITE_GITHUB_URL, key: 'github' }
    ]
  }
] as const

export const SOCIAL_LINKS: SocialLinks = [
  {
    href: SITE_GITHUB_URL,
    title: 'GitHub',
    icon: SiGithub
  },
  {
    href: SITE_X_URL,
    title: 'LinkedIn',
    icon: FaLinkedin as unknown as React.ComponentType<
      React.SVGProps<SVGSVGElement> & { className?: string }
    >
  },
  {
    href: SITE_INSTAGRAM_URL,
    title: 'Instagram',
    icon: SiInstagram
  },
  {
    href: SITE_FACEBOOK_URL,
    title: 'Facebook',
    icon: SiFacebook
  },
  {
    href: SITE_YOUTUBE_URL,
    title: 'WhatsApp',
    icon: SiWhatsapp
  }
]
